import { googleTheme, hereTheme } from "../theme";

import { checkIsActiveHereMap } from 'entities/map/utils/utils';

const useTheme = () => (
  checkIsActiveHereMap() ? hereTheme : googleTheme
);

export default useTheme;
